// extracted by mini-css-extract-plugin
export var centerList = "_i5-6";
export var centerLoc = "_i5-a";
export var centerName = "_i5-9";
export var centerOptionBody = "_i5-8";
export var centerRow = "_i5-7";
export var centerStatus = "_i5-b";
export var empty = "_i5-5";
export var externalIcon = "_i5-c";
export var fieldHeader = "_i5-2";
export var fieldHelp = "_i5-4";
export var fieldLabel = "_i5-3";
export var panel = "_i5-0";
export var removeBtn = "_i5-d";
export var section = "_i5-1";